export default "__VITE_ASSET__24d06a24__"